import styled from 'styled-components'
import {
  Modal as AntdModal,
} from 'antd';

export const Modal = styled(AntdModal)``;
